module.exports = __webpack_public_path__ + "img/iata.6684ba42.png";